import { Component, Input } from '@angular/core';
import {
  TableComponent,
  TableTheme,
} from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';

@Component({
  selector: 'app-risk-unit-class-code',
  imports: [TableComponent, ColumnComponent],
  template: ` <app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [stripedRows]="false"
    recordLabel="Class code"
    recordLabelPlural="Class codes"
    [theme]="theme"
    [globalFilterFields]="[
      'code',
      'effectiveDate',
      'expireDate',
      'description',
      'comment',
    ]"
  >
    <app-column name="code" label="Class Code" width="25%" />
    <app-column
      name="effectiveDate"
      label="Effective Date"
      width="25%"
      format="d"
    />
    <app-column name="expireDate" label="Expire Date" width="25%" format="d" />
    <app-column name="description" label="Description" width="25%" />
    <app-column
      name="comment"
      label="Comment"
      [fullRow]="true"
      [fullRowLabel]="true"
    >
      <ng-template #item let-row>
        <span class="tw-text-wrap tw-leading-6">{{ row.comment }}</span>
      </ng-template>
    </app-column>
  </app-table>`,
  styles: [],
})
export class RiskUnitClassCodeComponent {
  @Input()
  dataSource: any;

  @Input()
  theme: TableTheme = 'Light';
}
